"use client";

import PropTypes from "prop-types";
import styled from "styled-components";
import { textColorSecondary } from "@churchofjesuschrist/eden-style-constants";
import { Text4 } from "@churchofjesuschrist/eden-text";
import { jsx as _jsx } from "react/jsx-runtime";
export const InternalUseOnlyLegend = styled(Text4).withConfig({
  componentId: "sc-1ysb13t-0"
})(["border:none;padding:0;color:", ";"], textColorSecondary);

/**
 * The Legend represents a caption for the content of its parent Fieldset component.
 */
const Legend = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(InternalUseOnlyLegend, {
    renderAs: "legend",
    ...props,
    children: children
  });
};
Legend.displayName = "Legend";
Legend.propTypes = {
  /** Content to render inside the Legend Component */
  children: PropTypes.node.isRequired
};
export default Legend;